import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  NotificationApiResponse,
  NotificationPayload,
  AdminNotificationsResponse,
} from "interface/notification";

export const notificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminNotifications: builder.query<
      AdminNotificationsResponse,
      void | { unread_only?: boolean }
    >({
      query: (params) => ({
        url: API.GET_ADMIN_NOTIFICATIONS,
        method: "GET",
        params: params ?? { unread_only: true },
      }),
      providesTags: ["Notification"],
    }),
    markAdminNotificationsRead: builder.mutation<
      NotificationApiResponse,
      void | { ids?: string[] }
    >({
      query: (body) => ({
        url: API.MARK_ADMIN_NOTIFICATIONS_READ,
        method: "PUT",
        body: body ?? {},
      }),
      // Don't invalidate here – caller refetches after a delay so list stays visible
    }),
    deleteAdminNotification: builder.mutation<
      NotificationApiResponse,
      string
    >({
      query: (id) => ({
        url: `/${API.GET_ADMIN_NOTIFICATIONS}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notification"],
    }),
    sendNotification: builder.mutation<NotificationApiResponse, NotificationPayload>({
      query: ({ params }) => ({
        url: API.GET_NOTIFICATION,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Notification"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onSuccess?.();
        } catch (error) {
          console.error("Failed to send notification:", error);
        }
      },
    }),
  }),
});

export const {
  useSendNotificationMutation,
  useGetAdminNotificationsQuery,
  useMarkAdminNotificationsReadMutation,
  useDeleteAdminNotificationMutation,
} = notificationApi;
